export type ItemId = number

export type Item = {
    id: ItemId, 
    name: string,
    price: number,
    description: string
}
export const items: Item[] = [
    {id: 2, name: "Przedmiot ogólnodostępny", price: 5, description: "SŁ10 żeby znaleść w zasobach"},
    {id: 2, name: "Przedmiot rzadki", price: 25, description: "SŁ8 żeby znaleść w zasobach"},
    {id: 2, name: "Przedmiot bardzo rzadki", price: 50, description: "SŁ6 żeby znaleść w zasobach"},
    {id: 2, name: "Przedmiot specjalistyczny", price: 100, description: "SŁ4 żeby znaleść w zasobach"},
]

export const itemsMap = new Map(items.map(item => [item.id, item]) )
